import { useQuery } from '@tanstack/react-query';
import { IChangePasswordResponse } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const sendOtp = async (email: string) => {
  const res = await apiManager.get<IChangePasswordResponse>(
    `/auth/admin/forget-password/${email}`
  );
  return res;
};


export const useSendOtp = (email: string) =>
  useQuery({
    queryKey: ["send_otp", email],
    queryFn: async (): Promise<IChangePasswordResponse> => {
      const res = await apiClient.get(ENDPOINTS.AUTH.SEND_OTP(email));
      return res.data;
    },
    enabled: false,
  });